import React from 'react';
import { motion } from 'framer-motion';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const BusinessCTASection = () => {
  return (
    <section id="contact" className="relative overflow-hidden bg-[var(--lp-contrast-bg)] py-24 text-[var(--lp-contrast-text)] lg:py-28">
      <div className="lp-grain absolute inset-0" />
      <div className="absolute left-1/2 top-0 h-64 w-[600px] -translate-x-1/2 rounded-full bg-[var(--lp-accent)]/15 blur-[100px]" />

      <div className="relative mx-auto max-w-4xl px-5 text-center sm:px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.55 }}
        >
          <p className="font-mono text-[11px] font-semibold tracking-[0.25em] text-[var(--lp-accent)]">
            
          </p>
          <h2 className="mt-4 text-4xl leading-[1.05] tracking-tight text-[var(--lp-contrast-text)] sm:text-5xl lg:text-6xl">
            Automate your hiring
            <span className="block text-[var(--lp-contrast-text)]/50">with prepxai.</span>
          </h2>
          <p className="mx-auto mt-6 max-w-xl text-base leading-relaxed text-[var(--lp-contrast-text)]/55">
            Interview 500, not 50, to get your best candidate. Book a demo and see your custom pipeline in action — from resume upload to final hire.
          </p>

          <div className="mt-10 flex flex-col justify-center gap-3 sm:flex-row">
            <a href="mailto:contact@prepxai.com?subject=Book%20a%20Demo">
              <Button
                size="lg"
                className="h-12 w-full rounded-full bg-[var(--lp-accent)] px-8 text-sm text-white hover:bg-[var(--lp-accent)]/90 sm:w-auto"
                iconName="Calendar"
                iconPosition="right"
              >
                Book a demo
              </Button>
            </a>
            <a href="mailto:contact@prepxai.com?subject=Sales%20Inquiry">
              <Button
                variant="outline"
                size="lg"
                className="h-12 w-full rounded-full border-[var(--lp-contrast-text)]/20 bg-transparent px-8 text-sm text-[var(--lp-contrast-text)] hover:bg-[var(--lp-contrast-text)]/10 sm:w-auto"
                iconName="Mail"
              >
                contact@prepxai.com
              </Button>
            </a>
          </div>

          <ul className="mt-10 flex flex-wrap justify-center gap-x-8 gap-y-3">
            {['14-day pilot available', 'No engineering setup', 'Custom pipeline in 48h'].map((item) => (
              <li key={item} className="flex items-center gap-2 text-sm text-[var(--lp-contrast-text)]/60">
                <Icon name="Check" size={14} className="text-[var(--lp-accent)]" />
                {item}
              </li>
            ))}
          </ul>
        </motion.div>
      </div>
    </section>
  );
};

export default BusinessCTASection;
